import "core-js/modules/es.array.concat.js";
import { getReq, postReq, putReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/franchisee");
export var getAllFranchises = function getAllFranchises() {
  return getReq(BASE_URL);
};
export var getFranchisee = function getFranchisee(id) {
  return getReq("".concat(BASE_URL, "/").concat(id));
};
export var createFranchisee = function createFranchisee(body) {
  return postReq(BASE_URL, body);
};
export var updateFranchisee = function updateFranchisee(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id), body);
};